module.exports = __webpack_public_path__ + "static/media/16UNODC26.b7b91b30.jpg";